export default __webpack_public_path__ + "static/media/downloads.85cda924.jpg";